import React from "react";
import styles from "../component/custom.module.css";
import Images from "./Images";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper";


const posts = [
  {
    id: "1",
    title: "",
    image: {
      src: require("../assets/winners-posts/Diksha-Pandey.webp"),
    },
    name: "Diksha Pandey",
    bio: "Founder of Ekta Nature Farming Producer Company Limited.",
    content: `Winner- 2023, awarded a grant of 15 Lakhs
              I never thought I would make it till the end. I am very thankful to moha: Stand on your feet for supporting women entrepreneurs. The grant of 15 Lakhs that I won helped me sustain & scale up my business.  I also plan to buy more machinery.`
  },
  {
    id: "2",
    title: "",
    image: {
      src: require("../assets/winners-posts/Gayatri-Varun.webp"),
    },
    name: "Gayatri Varun",
    bio: "Founder of Green Hermitage",
    content: "I thank moha: & entire team for giving such a platform for budding entrepreneurs. It did motivate me to scale up my business & innovate new products for my business. The most surprising thing is that the initiative is backed by and is an ideation of men & I think that speaks volumes about how we are progressing as a nation. "
  },
]

const TestimonialSwiper = ({ JurySelect }) => {
  return (
    <section className={styles.sliderSection} ref={JurySelect}>
      <div className="container-fluid">
        <h2>Winners 2023</h2>
        <div className={styles.sliderJury}>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            loop={true}
            spaceBetween={20}
            slidesPerView={3}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true, // Enable clickable pagination bullets
              // el: ".swiper-pagination", // Element to render pagination bullets
            }}
            // style={{ height: "500px" }}
            autoHeight={false}
            breakpoints={{
              300: {

                slidesPerView: 1,
              },
              768: {

                slidesPerView: 1,
              },
              1024: {

                slidesPerView: 3,
              },

            }}
            navigation={true}
            className="juryslider-container"
          >
            {/* {posts?.map((item, index) => (
              <SwiperSlide key={item.id} style={{ display: "flex", height: "100%" }}>
                <div className={styles.sliderMain}>
                  <span className={styles.testimonialComment}>
                    {item.content}
                  </span>
                  <div className={styles.sliderInner2}>
                    <img
                      className={styles.sliderProfileImg2}
                      src={item.image.src}
                    />
                    <div className={styles.sliderInnerInfo}>
                      <p>{item.name}</p>
                      <span>{item.bio}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))} */}
            <SwiperSlide >
              <div className={styles.sliderMain}>
                <span className={styles.testimonialComment}>
                  "Winner- 2023, awarded a grant of 15 Lakhs
                  I never thought I would make it till the end. I am very thankful to moha: Stand on your feet for supporting women entrepreneurs. The grant of 15 Lakhs that I won helped me sustain & scale up my business.  I also plan to buy more machinery."
                </span>
                <div className={styles.sliderInner2}>
                  <img
                    class={styles.sliderProfileImg2}
                    src={Images.deeksha_panday_thumbnail}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Mrs. Deeksha Pandey</p>
                    <span>Founder of Ekta Nature Farming Producer Company Limited.</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={styles.sliderMain}>
                <span className={styles.testimonialComment}>
                  I thank moha: & entire team for giving such a platform for budding entrepreneurs. It did motivate me to scale up my business & innovate new products for my business. The most surprising thing is that the initiative is backed by and is an ideation of men & I think that speaks volumes about how we are progressing as a nation.
                </span>
                <div className={styles.sliderInner2}>
                  <img
                    class={styles.sliderProfileImg2}
                    src={Images.gayatri_varun_thumbnail}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Gayatri Varun</p>
                    <span>Founder of Green Hermitage</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={styles.sliderMain}>
                <span className={styles.testimonialComment}>
                  "I am extremely happy to be the winner of moha: Stand on your
                  feet. The 10 Lakh grant has helped me expand my set up & buy
                  new machinery & improve my marketing. I have improvised on the
                  look & feel of my product too & I am glad for it as it has
                  given me good growth. Thank you team moha: & Dr. Ram Shroff
                  for changing my life"
                </span>
                <div className={styles.sliderInner2}>
                  <img
                    className={styles.sliderProfileImg2}
                    src={Images.MsVidhyaJoshi}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Vidhya Joshi</p>
                    <span>Founder of Nutri Milletes</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={styles.sliderMain}>
                <span className={styles.testimonialComment}>
                  "I am very very thankful to moha: Stand on your feet for
                  supporting women entrepreneurs. The grant of 3 Lakh helped me
                  sustain & scale up my business. We were able to upgrade our
                  technology & now reach out to wider audiences pan India."
                </span>
                <div className={styles.sliderInner2}>
                  <img
                    className={styles.sliderProfileImg2}
                    src={Images.MsNayantara}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Nayantara</p>
                    <span>Co- Founder, Vidhyadhara Consultancy</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={styles.sliderMain}>
                <span className={styles.testimonialComment}>
                  "I thank moha: & entire team for giving such a platform for
                  budding entrepreneurs like me. It did motivate me to scale up
                  my business & innovate new products for my business."
                </span>
                <div className={styles.sliderInner2}>
                  <img
                    className={styles.sliderProfileImg2}
                    src={Images.MsChristina}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Christina</p>
                    <span>Founder, Maw & Paw</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSwiper;
